import { useQuery } from '@tanstack/react-query'

import { useQueryWithStorage } from '@hooks/useQueryWithStorage'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchKpi, initialState } from '../services/fetchKpi'

import { useKpiStore } from './useKpiStore'

export { useKpi, queryKey }

const queryKey = 'hoofdleiding-dashboard-kpi'

const useQueryStore = () => {
  const { query, storeQuery } = useKpiStore()

  return useQueryWithStorage({
    initialState: initialState,
    query,
    storeQuery,
    queryKey,
  })
}

const useKpi = () => {
  const { onChangeFilters, onReset, query } = useQueryStore()
  const { hasPermissions } = useAuthenticatedUser()

  const { data, refetch, isFetching, isError } = useQuery({
    queryKey: [queryKey, query],
    queryFn: () => fetchKpi({ query }),
    enabled: hasPermissions,
    refetchOnMount: true,
  })

  return {
    data: data || initialState.data,
    isLoading: isFetching,
    isError,
    filters: query.filters,
    initialFilters: initialState.query.filters,
    onChangeFilters,
    onReset,
    onRefresh: refetch,
  }
}
